var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 6.66672V10.0001M8.54162 4.58338H5.66663C4.26649 4.58338 3.56643 4.58338 3.03165 4.85587C2.56124 5.09555 2.17879 5.478 1.93911 5.94841C1.66662 6.48319 1.66663 7.18325 1.66663 8.58338L1.66663 9.58338C1.66663 10.36 1.66663 10.7482 1.7935 11.0545C1.96265 11.4629 2.28711 11.7874 2.69549 11.9565C3.00177 12.0834 3.39006 12.0834 4.16663 12.0834V15.625C4.16663 15.8185 4.16663 15.9153 4.17465 15.9967C4.25259 16.788 4.87864 17.4141 5.66993 17.492C5.75142 17.5 5.84815 17.5 6.04163 17.5C6.2351 17.5 6.33184 17.5 6.41332 17.492C7.20462 17.4141 7.83067 16.788 7.9086 15.9967C7.91663 15.9153 7.91663 15.8185 7.91663 15.625V12.0834H8.54163C10.0137 12.0834 11.8143 12.8725 13.2035 13.6298C14.014 14.0715 14.4192 14.2924 14.6846 14.2599C14.9307 14.2298 15.1168 14.1193 15.2611 13.9176C15.4166 13.7002 15.4166 13.2651 15.4166 12.3948V4.27195C15.4166 3.40171 15.4166 2.96659 15.2611 2.74912C15.1168 2.54747 14.9307 2.43697 14.6846 2.40682C14.4192 2.37432 14.014 2.59521 13.2035 3.03701C11.8143 3.79431 10.0136 4.58338 8.54162 4.58338Z",
    stroke: "#667185",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds);
export default __webpack_public_path__ + "static/media/ads.71fbe39319797a72cd84dcacd53dce9b.svg";
export { ForwardRef as ReactComponent };